import type { piniaPlaceHolder } from '../util/types';
import { type NuxtApp, useNuxtApp } from 'nuxt/app';
import type { App } from 'vue';

interface IClient {
  app: NuxtApp['vueApp'];

  addresses: string[];
  clinicalTrialEntityId: number;
  id: number;
  name: string;
  organizationId: number;
  phoneNumbers: string[];

  createChannel(params: { clientId: number; studyName: string }): Promise<void>;
}

class Client implements IClient {
  app: App<Element>;
  addresses: string[];
  clinicalTrialEntityId: number;
  id: number;
  name: string;
  organizationId: number;
  phoneNumbers: string[];

  constructor(data: {
    addresses: string[];
    clinicalTrialEntityId: number;
    id: number;
    name: string;
    organizationId: number;
    phoneNumbers: string[];
  }) {
    this.app = useNuxtApp().vueApp;
    this.addresses = data.addresses;
    this.clinicalTrialEntityId = data.clinicalTrialEntityId;
    this.id = data.id;
    this.name = data.name;
    this.organizationId = data.organizationId;
    this.phoneNumbers = data.phoneNumbers;
  }
  async createChannel({
    clientId,
    studyName,
  }: {
    clientId?: number;
    studyName: string;
  }): Promise<void> {
    const pinia = useNuxtApp().$pinia as piniaPlaceHolder;

    const finalClientId = clientId ?? this.id;

    await pinia.$axios.$post(
      pinia.$API.clients.createNewChannel(finalClientId),
      {
        studyName: studyName.trim(),
        orderType: 'QUOTATION',
      }
    );
  }
}

export type ClientInput = ConstructorParameters<typeof Client>[0];

export default Client;
